import React from 'react';
import { FiBookOpen } from 'react-icons/fi';
import MathMarkdown from './MathMarkdown';

function ModelAnswerPanel({ title, value, emptyMessage = '저장된 모범답안이 없습니다.' }) {
  const answer = typeof value === 'string' ? value.trim() : '';

  return (
    <section className="ai-essay-result-panel ai-essay-model-answer" aria-label={title}>
      <header>
        <span><FiBookOpen aria-hidden="true" /></span>
        <div><h2>{title}</h2></div>
      </header>
      <MathMarkdown className="ai-essay-markdown" value={answer || emptyMessage} />
    </section>
  );
}

export default ModelAnswerPanel;
